import { createSlice, createAsyncThunk } from "@reduxjs/toolkit"
import * as api from "../api"

export const addContact = createAsyncThunk("add-contact", async (payload) => {
    const response = await api.addContact(payload)
    return response
})

export const editContact = createAsyncThunk("edit-contact", async (payload) => {
    const response = await api.editContact(payload)
    return response
})

export const inviteContact = createAsyncThunk("invite-contact", async (id) => {
    const response = await api.inviteContact(id)
    return response
})

export const clearContact = createAsyncThunk("clear-contact", async () => {
    return
})

export const switchAgency = createAsyncThunk("switch-agency", async (payload) => {
    const response = await api.switchAgency(payload)
    return response
})

export const getContact = createAsyncThunk("get-contact", async (id) => {
    const response = await api.getContact(id)
    return response
})
const contactSlice = createSlice({
    name: "contact",
    initialState: {
        data: [],
        contact: {},
        fetchStatus: "",
        action: ""
    },
    reducers: {
        updateContact(state, action) {
            const { field, value } = action.payload
            state.contact = { ...state.contact, [field]: value }
        }
    },
    extraReducers: (builder) => {
        builder
            .addCase(editContact.fulfilled, (state, action) => {
                state.fetchStatus = "success"
                state.action = "editContact"
            })
            .addCase(editContact.pending, (state) => {
                state.fetchStatus = "loading"
                state.action = "editContact"
            })
            .addCase(editContact.rejected, (state) => {
                state.fetchStatus = "error"
                state.action = "editContact"
            })
            .addCase(addContact.fulfilled, (state, action) => {
                state.fetchStatus = "success"
                state.action = "addContact"
            })
            .addCase(addContact.pending, (state) => {
                state.fetchStatus = "loading"
                state.action = "addContact"
            })
            .addCase(addContact.rejected, (state) => {
                state.fetchStatus = "error"
                state.action = "addContact"
            })
            .addCase(inviteContact.fulfilled, (state, action) => {
                state.fetchStatus = "success"
                state.action = "inviteContact"
            })
            .addCase(inviteContact.pending, (state) => {
                state.fetchStatus = "loading"
                state.action = "inviteContact"
            })
            .addCase(inviteContact.rejected, (state) => {
                state.fetchStatus = "error"
                state.action = "inviteContact"
            })
            .addCase(clearContact.fulfilled, (state, action) => {
                state.contact = {}
                state.action = "clearContact"
            })
            .addCase(clearContact.pending, (state) => {
                state.action = "clearContact"
            })
            .addCase(clearContact.rejected, (state) => {
                state.action = "clearContact"
            })
            .addCase(switchAgency.fulfilled, (state, action) => {
                state.fetchStatus = "success"
                state.action = "switchAgency"
            })
            .addCase(switchAgency.pending, (state) => {
                state.fetchStatus = "loading"
                state.action = "switchAgency"
            })
            .addCase(switchAgency.rejected, (state) => {
                state.fetchStatus = "error"
                state.action = "switchAgency"
            })
            .addCase(getContact.fulfilled, (state, action) => {
                state.contact = action.payload
                state.action = "getContact"
                state.fetchStatus = "success"
            })
            .addCase(getContact.pending, (state) => {
                state.action = "getContact"
                state.fetchStatus = "loading"
            })
            .addCase(getContact.rejected, (state) => {
                state.action = "getContact"
            })
    }
})

export default contactSlice

export const { name, actions, reducers } = contactSlice
